import { render } from "./PedidoNuevo.vue?vue&type=template&id=399eb19c&scoped=true"
import script from "./PedidoNuevo.vue?vue&type=script&lang=js"
export * from "./PedidoNuevo.vue?vue&type=script&lang=js"

import "./PedidoNuevo.vue?vue&type=style&index=0&id=399eb19c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-399eb19c"]])

export default __exports__